export default "__VITE_ASSET__BQn$tOYY__"